import { c as _c } from "react/compiler-runtime";
import { DateRangeCustomFilterEnum, DateRangePicker, getDate, setDateWithTimezone, Tabbar } from '@systemeio/components';
import { CurrencyEnum } from '@systemeio/types';
import { AffiliateDashboardIdCard } from 'modules/affiliate-dashboard/components/affiliate-dashboard-id-card';
import AffiliateDashboardInvoices from 'modules/affiliate-dashboard/components/affiliate-dashboard-invoices';
import AffiliateDashboardLeads from 'modules/affiliate-dashboard/components/affiliate-dashboard-leads';
import AffiliateDashboardPayments from 'modules/affiliate-dashboard/components/affiliate-dashboard-payments';
import AffiliateDashboardPromotion from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion';
import AffiliateDashboardVendorSelector from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-selector';
import { AffiliateDashboardLoco } from 'modules/affiliate-dashboard/constants/affiliate-dashboard-loco';
import { useAffiliateActivity } from 'modules/affiliate-dashboard/hooks/use-affiliate-activity';
import { useAffiliateDashboardChart } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-chart';
import { useAffiliateDashboardStatistic } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-statistic';
import { useAffiliateDashboardTags } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-tags';
import { AffiliateDashboardFilterInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateCommissionChart } from 'modules/affiliate/components/affiliate-commission-chart';
import { AffiliateEarningsCard } from 'modules/affiliate/components/affiliate-earnings-card';
import { AffiliateOverview } from 'modules/affiliate/components/affiliate-overview-layout';
import { AffiliateSectionTabList } from 'modules/affiliate/components/affiliate-section-tabs';
import { AffiliateSection } from 'modules/affiliate/types/affiliate-section';
import { AffiliateStatisticDateFilterInterface } from 'modules/affiliate/types/affiliate-statistic-interface';
import { isDefaultFilter } from 'modules/affiliate/utils/is-default-filter';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { FormSelect } from 'shared/components';
import { FilterHeader } from 'shared/components/filter-header';
import { useCurrencySubsetData } from 'shared/hooks/use-currency-data';
import { toFilterGroup, useFilterDraft } from 'shared/hooks/use-filter-draft';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getDatePickerMinDate } from 'shared/utils/get-date-picker-min-date';
import { getMonthDateRange, getToday } from 'shared/utils/get-dates';
const defaultFilter: AffiliateDashboardFilterInterface = {
  dateTill: null,
  dateSince: null,
  vendorId: undefined,
  currency: undefined
};
const AffiliateDashboard: NextPage = () => {
  const $ = _c(119);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const router = useRouter();
  const [tab, setTab] = useState(router.query.purchaseInvoiceId ? "invoices" : "payments");
  let t0;
  let t1;
  if ($[0] !== router.query.purchaseInvoiceId) {
    t0 = () => {
      if (router.query.purchaseInvoiceId) {
        setTab("invoices");
      }
    };
    t1 = [router.query.purchaseInvoiceId];
    $[0] = router.query.purchaseInvoiceId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const [tagsData, setTagsData] = useState(undefined);
  const {
    filter,
    setFilter,
    defaultFilter: defaults
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  const {
    data: affiliateTags
  } = useAffiliateDashboardTags();
  const {
    data: affiliateStatistic
  } = useAffiliateDashboardStatistic(filter.vendorId);
  const {
    data: affiliateChart
  } = useAffiliateDashboardChart(filter);
  const {
    hasCommissions
  } = useAffiliateActivity();
  let t2;
  if ($[3] !== affiliateStatistic) {
    t2 = affiliateStatistic ? Object.keys(affiliateStatistic.total) as CurrencyEnum[] : undefined;
    $[3] = affiliateStatistic;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currencies = t2;
  const currencyData = useCurrencySubsetData(currencies);
  let t3;
  let t4;
  if ($[5] !== affiliateTags) {
    t3 = () => {
      if (affiliateTags) {
        setTagsData(affiliateTags.affiliateTags.map(_temp));
      }
    };
    t4 = [affiliateTags];
    $[5] = affiliateTags;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== setFilter) {
    t5 = values => setFilter(values);
    $[8] = setFilter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== defaults || $[11] !== filter || $[12] !== t5) {
    t6 = {
      applied: filter,
      defaults,
      onApply: t5
    };
    $[10] = defaults;
    $[11] = filter;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const state = useFilterDraft(t6);
  let t7;
  if ($[14] !== t) {
    t7 = t("header.top_menu.affiliate_dashboard");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== affiliateStatistic || $[17] !== currencyData || $[18] !== intlLocale || $[19] !== state || $[20] !== t || $[21] !== user) {
    let t9;
    if ($[23] !== user?.timezone) {
      t9 = () => getMonthDateRange(user?.timezone);
      $[23] = user?.timezone;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== state.draft.dateSince || $[26] !== state.draft.dateTill) {
      t10 = [state.draft.dateSince, state.draft.dateTill];
      $[25] = state.draft.dateSince;
      $[26] = state.draft.dateTill;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    const t11 = user?.timezone;
    let t12;
    if ($[28] !== t11) {
      t12 = getToday(t11);
      $[28] = t11;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    let t13;
    if ($[30] !== state) {
      t13 = date => {
        const newFilterState = {
          dateSince: date[0],
          dateTill: date[1]
        };
        state.setDraft(prev => ({
          ...prev,
          ...newFilterState
        }));
      };
      $[30] = state;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    const t14 = user?.createdAt;
    const t15 = user?.timezone;
    let t16;
    if ($[32] !== t14 || $[33] !== t15 || $[34] !== user?.affiliateAccountCreatedAt || $[35] !== user?.timezone) {
      t16 = getDatePickerMinDate(t14, t15, user?.affiliateAccountCreatedAt ? getDate(user?.affiliateAccountCreatedAt, user?.timezone) : undefined, "date-range-picker");
      $[32] = t14;
      $[33] = t15;
      $[34] = user?.affiliateAccountCreatedAt;
      $[35] = user?.timezone;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    let t17;
    if ($[37] !== user) {
      t17 = [{
        slug: DateRangeCustomFilterEnum.AllTime,
        handler: () => {
          const today = setDateWithTimezone("", user?.timezone);
          today.setHours(23, 59, 59, 999);
          if (!user?.affiliateAccountCreatedAt) {
            return [today, today];
          }
          const firstDate = setDateWithTimezone(user.affiliateAccountCreatedAt, user?.timezone);
          return [firstDate, today];
        }
      }];
      $[37] = user;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    const t18 = user?.timezone;
    let t19;
    if ($[39] !== intlLocale || $[40] !== t10 || $[41] !== t12 || $[42] !== t13 || $[43] !== t16 || $[44] !== t17 || $[45] !== t18 || $[46] !== t9) {
      t19 = <DateRangePicker getDefaultDate={t9} date={t10} maxDate={t12} onChange={t13} minDate={t16} customFilters={t17} timezone={t18} intlLocale={intlLocale} />;
      $[39] = intlLocale;
      $[40] = t10;
      $[41] = t12;
      $[42] = t13;
      $[43] = t16;
      $[44] = t17;
      $[45] = t18;
      $[46] = t9;
      $[47] = t19;
    } else {
      t19 = $[47];
    }
    const t20 = !affiliateStatistic;
    let t21;
    if ($[48] !== t) {
      t21 = t("global.currency");
      $[48] = t;
      $[49] = t21;
    } else {
      t21 = $[49];
    }
    let t22;
    if ($[50] !== state) {
      t22 = data => state.setDraft(prev_0 => ({
        ...prev_0,
        currency: data
      }));
      $[50] = state;
      $[51] = t22;
    } else {
      t22 = $[51];
    }
    let t23;
    if ($[52] !== currencyData || $[53] !== state.draft.currency || $[54] !== t20 || $[55] !== t21 || $[56] !== t22) {
      t23 = <FormSelect disabled={t20} data={currencyData} placeholder={t21} value={state.draft.currency} onChange={t22} />;
      $[52] = currencyData;
      $[53] = state.draft.currency;
      $[54] = t20;
      $[55] = t21;
      $[56] = t22;
      $[57] = t23;
    } else {
      t23 = $[57];
    }
    let t24;
    if ($[58] !== state.draft.vendorId || $[59] !== state.setDraft) {
      t24 = <AffiliateDashboardVendorSelector selectedVendor={state.draft.vendorId} setFilter={state.setDraft} />;
      $[58] = state.draft.vendorId;
      $[59] = state.setDraft;
      $[60] = t24;
    } else {
      t24 = $[60];
    }
    t8 = toFilterGroup(state, [{
      key: "date",
      fields: ["dateSince", "dateTill"],
      node: t19
    }, {
      key: "currency",
      node: t23
    }, {
      key: "vendorId",
      node: t24
    }]);
    $[16] = affiliateStatistic;
    $[17] = currencyData;
    $[18] = intlLocale;
    $[19] = state;
    $[20] = t;
    $[21] = user;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[61] !== t7 || $[62] !== t8) {
    t9 = <FilterHeader title={t7} filters={t8} />;
    $[61] = t7;
    $[62] = t8;
    $[63] = t9;
  } else {
    t9 = $[63];
  }
  const t10 = affiliateStatistic?.total;
  let t11;
  if ($[64] !== affiliateChart || $[65] !== affiliateStatistic?.last30Days || $[66] !== filter || $[67] !== user?.timezone) {
    t11 = isDefaultFilter(filter, user?.timezone) ? affiliateStatistic?.last30Days : affiliateChart;
    $[64] = affiliateChart;
    $[65] = affiliateStatistic?.last30Days;
    $[66] = filter;
    $[67] = user?.timezone;
    $[68] = t11;
  } else {
    t11 = $[68];
  }
  let t12;
  if ($[69] !== hasCommissions || $[70] !== t) {
    t12 = hasCommissions === false ? {
      title: t("dashboard.affiliate_dashboard.chart.empty.title"),
      description: t("dashboard.affiliate_dashboard.chart.empty.description")
    } : undefined;
    $[69] = hasCommissions;
    $[70] = t;
    $[71] = t12;
  } else {
    t12 = $[71];
  }
  let t13;
  if ($[72] !== filter.currency || $[73] !== t10 || $[74] !== t11 || $[75] !== t12) {
    t13 = <AffiliateOverview.Chart><AffiliateCommissionChart height={232} total={t10} selectedCurrency={filter.currency} chartData={t11} emptyStateProps={t12} /></AffiliateOverview.Chart>;
    $[72] = filter.currency;
    $[73] = t10;
    $[74] = t11;
    $[75] = t12;
    $[76] = t13;
  } else {
    t13 = $[76];
  }
  let t14;
  if ($[77] !== affiliateStatistic || $[78] !== filter.currency) {
    t14 = <AffiliateEarningsCard selectedCurrency={filter.currency} affiliateStatistic={affiliateStatistic} />;
    $[77] = affiliateStatistic;
    $[78] = filter.currency;
    $[79] = t14;
  } else {
    t14 = $[79];
  }
  let t15;
  if ($[80] !== affiliateStatistic) {
    t15 = <AffiliateDashboardIdCard affiliateStatistic={affiliateStatistic} />;
    $[80] = affiliateStatistic;
    $[81] = t15;
  } else {
    t15 = $[81];
  }
  const t16 = affiliateStatistic?.user.affiliateAccount.affiliateId;
  let t17;
  if ($[82] !== t16) {
    t17 = <AffiliateDashboardPromotion affiliateId={t16} />;
    $[82] = t16;
    $[83] = t17;
  } else {
    t17 = $[83];
  }
  let t18;
  if ($[84] !== t15 || $[85] !== t17) {
    t18 = <div className="flex min-w-0 flex-col gap-5">{t15}{t17}</div>;
    $[84] = t15;
    $[85] = t17;
    $[86] = t18;
  } else {
    t18 = $[86];
  }
  let t19;
  if ($[87] !== t14 || $[88] !== t18) {
    t19 = <AffiliateOverview.Aside>{t14}{t18}</AffiliateOverview.Aside>;
    $[87] = t14;
    $[88] = t18;
    $[89] = t19;
  } else {
    t19 = $[89];
  }
  let t20;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = value => setTab(value as AffiliateSection);
    $[90] = t20;
  } else {
    t20 = $[90];
  }
  let t21;
  if ($[91] !== t) {
    t21 = t("header.top_menu.affiliate_dashboard");
    $[91] = t;
    $[92] = t21;
  } else {
    t21 = $[92];
  }
  let t22;
  if ($[93] !== t21) {
    t22 = <AffiliateSectionTabList ariaLabel={t21} />;
    $[93] = t21;
    $[94] = t22;
  } else {
    t22 = $[94];
  }
  let t23;
  if ($[95] !== filter || $[96] !== setFilter || $[97] !== tagsData) {
    t23 = <Tabbar.Panel value="payments" keepMounted={true}><AffiliateDashboardPayments setMainFilter={setFilter} mainFilter={filter} tagsData={tagsData} /></Tabbar.Panel>;
    $[95] = filter;
    $[96] = setFilter;
    $[97] = tagsData;
    $[98] = t23;
  } else {
    t23 = $[98];
  }
  let t24;
  if ($[99] !== filter || $[100] !== setFilter || $[101] !== tagsData) {
    t24 = <Tabbar.Panel value="leads" keepMounted={true}><AffiliateDashboardLeads setMainFilter={setFilter} mainFilter={filter} tagsData={tagsData} /></Tabbar.Panel>;
    $[99] = filter;
    $[100] = setFilter;
    $[101] = tagsData;
    $[102] = t24;
  } else {
    t24 = $[102];
  }
  let t25;
  if ($[103] !== filter || $[104] !== setFilter) {
    t25 = <Tabbar.Panel value="invoices" keepMounted={true}><AffiliateDashboardInvoices mainFilter={filter} setMainFilter={setFilter} /></Tabbar.Panel>;
    $[103] = filter;
    $[104] = setFilter;
    $[105] = t25;
  } else {
    t25 = $[105];
  }
  let t26;
  if ($[106] !== t22 || $[107] !== t23 || $[108] !== t24 || $[109] !== t25 || $[110] !== tab) {
    t26 = <AffiliateOverview.Sections><Tabbar.Root value={tab} onValueChange={t20}>{t22}{t23}{t24}{t25}</Tabbar.Root></AffiliateOverview.Sections>;
    $[106] = t22;
    $[107] = t23;
    $[108] = t24;
    $[109] = t25;
    $[110] = tab;
    $[111] = t26;
  } else {
    t26 = $[111];
  }
  let t27;
  if ($[112] !== t13 || $[113] !== t19 || $[114] !== t26) {
    t27 = <AffiliateOverview.Root>{t13}{t19}{t26}</AffiliateOverview.Root>;
    $[112] = t13;
    $[113] = t19;
    $[114] = t26;
    $[115] = t27;
  } else {
    t27 = $[115];
  }
  let t28;
  if ($[116] !== t27 || $[117] !== t9) {
    t28 = <div className="flex flex-col gap-5">{t9}{t27}</div>;
    $[116] = t27;
    $[117] = t9;
    $[118] = t28;
  } else {
    t28 = $[118];
  }
  return t28;
};
export const getServerSideProps = getBaseServerSideProps(AffiliateDashboardLoco, 'header.top_menu.affiliate_dashboard');
export default AffiliateDashboard;
function _temp(el) {
  return {
    id: el.id,
    caption: el.name
  };
}